import React from "react";
import { Breadcrumb, Divider, Typography, Space, Badge } from "antd";
import { useDocumentsData } from "./useDocumentsData";
import { useProvince } from "./useProvince";
import { useRegioni } from "./useRegioni";
import DocumentsExplorer from "./DocumentsExplorer";

const { Title } = Typography;

// Pagina globale /documents: carica tutti i documenti + coordinate e mostra l'explorer
// con tutte le funzionalità attive.
const Documenti = () => {
  const { docs, loading, error } = useDocumentsData();
  const province = useProvince();
  const regioni = useRegioni();

  return (
    <DocumentsExplorer
      docs={docs}
      loading={loading}
      error={error}
      regioni={regioni}
      province={province}
      renderHeader={(count) => (
        <>
          <Breadcrumb style={{ marginBottom: 20 }} items={[{ title: "Eterno" }, { title: "Documenti" }]} />
          <Divider />
          <Title level={3} style={{ marginBottom: 24 }}>
            <Space>
              Documenti Personalizzati
              <Badge overflowCount={5000} count={count} />
            </Space>
          </Title>
        </>
      )}
    />
  );
};

export default Documenti;
